export default __webpack_public_path__ + "static/media/happyFeeling.17050c95.svg";